import {
  ACTUAL_STATE_IMAGE_ADD,
  ACTUAL_STATE_IMAGE_DELETE,
  CHECK_ITEM_IMAGE_ADD,
  CHECK_ITEM_IMAGE_DELETE
} from "./mutation-types";
import * as localforage from "localforage";
import { errorMessage } from "@/services/MessageService";

export default {
  /**
   * Add image to local forage an updates the object in the vuex store
   * @param {*} refUploadInput receives an object with the full size image
   * as the attribute 'output', the thumbnail
   * as the attribute 'thumbnail' and the 'id' of the image
   */
  async addImage({ commit }, refUploadInput) {
    try {
      await localforage.setItem(refUploadInput.id, refUploadInput);
      commit(ACTUAL_STATE_IMAGE_ADD, refUploadInput);
    } catch (error) {
      errorMessage("Ocurrió un error al agregar imágen");
    }
  },
  /**
   * Remove single image of actual state from state and local forage
   * @param {*} id receives the id of the image that's going to be deleted
   */
  async deleteImage({ commit }, id) {
    try {
      await localforage.removeItem(id);
      commit(ACTUAL_STATE_IMAGE_DELETE, id);
    } catch (error) {
      errorMessage("Ocurrió un error al borrar imágen");
    }
  },
  /**
   * Add image to local forage an updates the object in the vuex store
   * @param {*} refUploadInput receives an object with the full size image
   * as the attribute 'output', the thumbnail
   * as the attribute 'thumbnail' and the 'id' of the image
   */
  async addCheckItemImage({ commit }, refUploadInput) {
    try {
      await localforage.setItem(refUploadInput.id, refUploadInput);
      commit(CHECK_ITEM_IMAGE_ADD, refUploadInput);
    } catch (error) {
      errorMessage("Ocurrió un error al agregar imágen");
    }
  },
  /**
   * Remove single image of check item from state and local forage
   * @param {*} id receives the id of the image that's going to be deleted
   */
  async deleteCheckItemImage({ commit }, id) {
    try {
      await localforage.removeItem(id);
      commit(CHECK_ITEM_IMAGE_DELETE, id);
    } catch (error) {
      errorMessage("Ocurrió un error al borrar imágen");
    }
  }
};
